import { STATISTICS_COLORS } from './statisticsHelpers';

/**
 * Componente para visualizar una estadística individual con barras comparativas
 * @param {Object} stat - Objeto con datos de la estadística
 * @param {string} stat.key - Clave única de la estadística
 * @param {string} stat.label - Etiqueta visible
 * @param {number} stat.homeValue - Valor del equipo local
 * @param {number} stat.awayValue - Valor del equipo visitante
 * @param {number} stat.homePercentage - Porcentaje relativo del equipo local
 * @param {number} stat.awayPercentage - Porcentaje relativo del equipo visitante
 */
export default function StatisticRow({ stat }) {
  // Estadísticas que se muestran con símbolo de porcentaje
  const PERCENTAGE_STATS = ['possession'];
  const isPercentageStat = PERCENTAGE_STATS.includes(stat.key);

  // Formato del valor dependiendo si es porcentaje
  const formatValue = (value) => {
    return isPercentageStat ? `${value}%` : value;
  };

  return (
    <div className="statistic-row">
      <div className="stat-value stat-value--home">
        <span className="stat-number">{formatValue(stat.homeValue)}</span>
      </div>

      <div className="stat-bars-container">
        <div className="stat-label">{stat.label}</div>
        <div className="stat-bars">
          <div
            className="stat-bar stat-bar--home"
            style={{
              width: `${stat.homePercentage}%`,
              backgroundColor: STATISTICS_COLORS.HOME,
            }}
            role="progressbar"
            aria-valuenow={Math.round(stat.homePercentage)}
            aria-valuemin="0"
            aria-valuemax="100"
            aria-label={`${stat.label} equipo local: ${stat.homeValue}`}
          />
          <div
            className="stat-bar stat-bar--away"
            style={{
              width: `${stat.awayPercentage}%`,
              backgroundColor: STATISTICS_COLORS.AWAY,
            }}
            role="progressbar"
            aria-valuenow={Math.round(stat.awayPercentage)}
            aria-valuemin="0"
            aria-valuemax="100"
            aria-label={`${stat.label} equipo visitante: ${stat.awayValue}`}
          />
        </div>
      </div>

      <div className="stat-value stat-value--away">
        <span className="stat-number">{formatValue(stat.awayValue)}</span>
      </div>
    </div>
  );
}